const PublicationsData = {
    2026: [
      {
        id: 1,
        citation: "Reardon B, Culhane AC, Van Allen EM. \"Convergence of machine learning and genomics for precision oncology\". Eng. In: Nat Rev Cancer. (Jan. 2026). Epub ahead of print.",
        doi: "10.1038/s41568-025-00897-6",
        pmid: "41478861"
      },
      {
        id: 2,
        citation: "Reardon B, Camp SY, O'Mahoney G, Vergara M, Lawler M, Van Allen EM, Culhane AC. \"A standard operating procedure to enable global, regionally-guided precision oncology knowledge bases\". (2026).",
        doi: "10.5281/zenodo.18186568"
      }
    ],
    2025: [
      {
        id: 1,
        citation: "Couespel N, Lawler M. \"The European Cancer Pulse – From Data Intelligence to Policy Action\". Eng. In: Open Access Government (Jan. 2025).",
        link: "https://www.openaccessgovernment.org/article/the-european-cancer-pulse-from-data-intelligence-to-policy-action/187010/"
      },
      {
        id: 2,
        citation: "Adair O, Lamrock F, O'Mahony JF, Lawler M, McFerran E. \"A comparison of international modelling methods to evaluate health economics of colorectal cancer screening: a systematic review\". Eng. In: Value Health (Jan. 2025).",
        doi: "10.1016/j.jval.2025.01.007",
        pmid: "39880192"
      },
      {
        id: 3,
        citation: "Shah R, Hanna NM, Loo CE, David M, Mafra A, Fink H, McFerran E, Garcia M, Ghodssighassemabadi R, Acharya S, Niyibaga J, Langselius O, Frick C, Lasebikan N, Vignat J, Steinberg J, Hughes S, Kircher CE, Goldie CL, Egger S, Sullivan R, Ginsburg O, Bray F, Caruana M, Hui H, Ilbawi AM, Canfell K, Soerjomataram I. \"The global impact of the COVID-19 pandemic on delays and disruptions in cancer care services: a systematic review and meta-analysis\". Eng. In: Nat Cancer. 6.1 (Jan. 2025), pp. 194–204.",
        doi: "10.1038/s43018-024-00880-4",
        pmid: "39747650"
      },
      {
        id: 4,
        citation: "Underwood S, Oguzman E, Cole J, Goldacre R, Patel N, Davies D, Friedemann-Smith C, Wright FL, Lacey B, Nicholson BD, Shepperd S, Lawler M, Morris EJA. \"Cancer inequalities in the United Kingdom and the data used to measure them: a scoping review\". Eng. In: Lancet Reg Health Eur. 52 (Mar. 2025), p. 101246.",
        doi: "10.1016/j.lanepe.2025.101246",
        pmid: "40115079"
      },
      {
        id: 5,
        citation: "Drnevich J, Tan FJ, Almeida-Silva F, Castelo R, Culhane AC, Davis S, Doyle MA, Geistlinger L, Ghazi AR, Holmes S, Lahti L, Mahmoud A, Nishida K, Ramos M, Rue-Albrecht K, Shih DJH, Gatto L, Soneson C. \"Learning and teaching biological data science in the Bioconductor community\". Eng. In: PLoS Comput Biol. 21.4 (Apr. 2025), e1012925.",
        doi: "10.1371/journal.pcbi.1012925",
        pmid: "40261894"
      },
      {
        id: 6,
        citation: "Lawler M, Culhane AC, on behalf of the eHealth Hub for Cancer. \"Harnessing the Power of Data to Transform Cancer Research, Care and Innovation across the Island of Ireland\". eHealth Hub for Cancer Report (May 2025).",
        doi: "10.5281/zenodo.17170542"
      },
      {
        id: 7,
        citation: "Lawler M, McFerran E, Readman L, Gautama S, Koczan P, Palmer J, Wiltshire S, Pace E. \"Independent Economic Evaluation of the London Care Record\". Eng. In: London Care Record Report (May 2025).",
        link: "https://www.onelondon.online/wp-content/uploads/2025/09/London-Care-Record-Independent-Economic-Evaluation-July-2025.pdf"
      }
    ],
    2024: [
      // {
      //   id: 1, 
      //   citation: "Lawler M, Culhane A, Heenan D, Keatley D, Bennett D, Gaynor S, Lowery M, McCabe S. \"Harnessing the Power of Data to Transform Cancer Research, Care and Innovation Across the Island of Ireland\". Eng. In: eHealth Hub for Cancer. May 2025.",
      //   pdfUrl: "https://raw.githubusercontent.com/eHealthHub4Cancer/Harnessing-the-Power-of-Data-to-Transform-Cancer-Research/main/Harnessing%20the%20Power%20of%20Data%20for%20Cancer%2005-25%20090525%20Digital.pdf"
      // },
      {
        id: 2,
        citation: "Ward ZJ, Atun R, Aggarwal A, Lawler M, Hricak H.  \"Investing in cancer care in the UK: why aren't we acting on the evidence?\". Eng. In: Lancet Oncol. 25.12 (Dec. 2024), pp. 1522-1524.",
        doi: "10.1016/S1470-2045(24)00634-X",
        pmid: "39542007"
      },
      {
        id: 3,
        citation: "Popescu RA, Sullivan R, Aggarwal A, Lopes David BB, Valciņa O, Al Sendi M, Lawler M, Charalambous A, Aapro M, Hall C, Eniu A, Selby P. \"Improving cancer outcomes through enhanced leadership and strategy training for cancer healthcare professionals - A course developed by the European School of Oncology (ESO), the European Cancer Organization (ECO) and Sharing Progress in Cancer Care (SPCC)\". Eng. In: J Cancer Policy. 43 (Nov. 2024), p. 100517.",
        doi: "10.1016/j.jcpo.2024.100517",
        pmid: "39510379"
      },
      {
        id: 4,
        citation: "Faupel-Badger J, Kohaar I, Bahl M, Chan AT, Campbell JD, Ding L, De Marzo AM, Maitra A, Merrick DT, Hawk ET, Wistuba II, Ghobrial IM, Lippman SM, Lu KH, Lawler M, Kay NE, Tlsty TD, Rebbeck TR, Srivastava S. \"Defining precancer: a grand challenge for the cancer community\". Eng. In: Nat Rev Cancer. 24.11 (Nov. 2024), pp. 792-809.",
        doi: "10.1038/s41568-024-00744-0",
        pmid: "39354069"
      },
      {
        id: 5,
        citation: "Lawler M, Aggarwal A, Gralow J, Sullivan R, Price P\"The UK needs to be a leader, not a lagger, in the global cancer effort\". Eng. In: Lancet Oncol. 25.10 (Oct. 2024), pp. 1253-1254.",
        doi: "10.1016/S1470-2045(24)00448-0",
        pmid: "39178864"
      },
      {
        id: 6,
        citation: "Naidoo KL, Dorward J, Chinniah K, Lawler M, Nattar Y, Bottomley C, Archary M. \"Changes in the medical admissions and mortality amongst children in four South African hospitals following the COVID-19 pandemic: A five-year review\". Eng. In: PLOS Glob Public Health. 4.9 (Sep. 2024), p. e0002829.",
        doi: "10.1371/journal.pgph.0002829",
        pmid: "39292683"
      },
      {
        id: 7,
        citation: "Lawler M, Scocca G, Meunier F. \"Ending financial discrimination for cancer survivors: embedding the Right to be Forgotten in legislation across Europe\". Eng. In: Lancet Oncol. 25.9 (Sep. 2024), pp. 1123-1126.",
        doi: "10.1016/S1470-2045(24)00312-7",
        pmid: "39151444"
      },
      {
        id: 8,
        citation: "Lawler M, Keeling P, Kholmanskikh O, Minnaard W, Moehlig-Zuttermeister H, Normanno N, Philip R, Popp C, Salgado R, Santiago-Walker AE, Trullas A, van Doorn-Khosrovani SBVW, Vart R, Vermeulen J, Vitaloni M, Verweij J. \"Empowering effective biomarker-driven precision oncology: A call to action\". Eng. In: Eur J Cancer. 209 (Sep. 2024), p. 114225.",
        doi: "10.1016/j.ejca.2024.114225",
        pmid: "39053288"
      },
      {
        id: 9,
        citation: "Ghebreyesus TA, Mired D, Sullivan R, Mueller A, Charalambous A, Kacharian A, Tsagkaris C, Soto-Perez-de-Celis E, Grigoryan H, Gralow J, Ilbawi A, Ghanem K, Mula-Hussain L, Mikkelsen B, Yimer M, Hammad N, Arakelyan S, Kutluk T, Salman Z, Lawler M, Tamamyan G, Babak MV, Arakelyan J. \"A manifesto on improving cancer care in conflict-impacted populations\". Eng. In: Lancet. 404.10451 (Aug. 2024), p. 427.",
        doi: "10.1016/S0140-6736(24)01023-7",
        pmid: "39097383"
      },
      {
        id: 10,
        citation: "Carrera PM, Curigliano G, Santini D, Sharp L, Chan RJ, Pisu M, Perrone F, Karjalainen S, Numico G, Cherny N, Winkler E, Amador ML, Fitch M, Lawler M, Meunier F, Khera N, Pentheroudakis G, Trapani D, Ripamonti CI. \"ESMO expert consensus statements on the screening and management of financial toxicity in patients with cancer\". Eng. In: ESMO Open. 9.5 (May. 2024), p. 102992.",
        doi: "10.1016/j.esmoop.2024.102992",
        pmid: "38626634"
      },
      {
        id: 11,
        citation: "SMalla SB, Byrne RM, Lafarge MW, Corry SM, Fisher NC, Tsantoulis PK, Mills ML, Ridgway RA, Lannagan TRM, Najumudeen AK, Gilroy KL, Amirkhah R, Maguire SL, Mulholland EJ, Belnoue-Davis HL, Grassi E, Viviani M, Rogan E, Redmond KL, Sakhnevych S, McCooey AJ, Bull C, Hoey E, Sinevici N, Hall H, Ahmaderaghi B, Domingo E, Blake A, Richman SD, Isella C, Miller C, Bertotti A, Trusolino L, Loughrey MB, Kerr EM, Tejpar S; S:CORT consortium; Maughan TS, Lawler M, Campbell AD, Leedham SJ, Koelzer VH, Sansom OJ, Dunne PD. \"Pathway level subtyping identifies a slow-cycling biological phenotype associated with poor clinical outcomes in colorectal cancer\". Eng. In: Nat Genet. 56.3 (Mar. 2024), pp. 458-472.",
        doi: "10.1038/s41588-024-01654-5",
        pmid: "38351382"
      },
      {
        id: 12,
        citation: "McFerran E, Donaldson S, Dolan O, Lawler M. \"Skin in the game: The cost consequences of skin cancer diagnosis, treatment and care in Northern Ireland\". Eng. In: J Cancer Policy. 39 (Mar. 2024), p. 100468.",
        doi: "10.1016/j.jcpo.2024.100468",
        pmid: "38311308"
      },
      {
        id: 13,
        citation: "Nelson D, Selby P, Kane R, Harding-Bell A, Kenny A, McPeake K, Cooke S, Hogue T, Oliver K, Gussy M, Lawler M. \"Implementing the European code of cancer practice in rural settings\". Eng. In: J Cancer Policy. 39 (Mar. 2024), p. 100465.",
        doi: "10.1016/j.jcpo.2023.100465",
        pmid: "38184144"
      },
      {
        id: 14,
        citation: "Connolly H, Delimata N, Galway K, Kiely B, Lawler M, Mulholland J, O'Grady M, Connolly D. \"Exploration of Evaluation Practices in Social Prescribing Services in Ireland: A Cross-Sectional Observational Study\". Eng. In: Healthcare (Basel). 12.2 (Jan. 2024), p. 219.",
        doi: "10.3390/healthcare12020219",
        pmid: "38255106"
      },
      {
        id: 15,
        citation: "Aggarwal A, Choudhury A, Fearnhead N, Kearns P, Kirby A, Lawler M, Quinlan S, Palmieri C, Roques T, Simcock R, Walter FM, Price P, Sullivan R. \"The future of cancer care in the UK-time for a radical and sustainable National Cancer Plan\". Eng. In: Lancet Oncol. 25.1 (Jan. 2024), pp. e6-e17.",
        doi: "10.1016/S1470-2045(23)00511-9",
        pmid: "37977167"
      },
      {
        id: 16,
        citation: "Riba M, Sala C, Culhane AC, Flobak Å, Patocs A, Boye K, Plevova K, Pospíšilová Š, Gandolfi G, Morelli MJ, Bucci G, Edsjö A, Lassen U, Al-Shahrour F, Lopez-Bigas N, Hovland R, Cuppen E, Valencia A, Poirel HA, Rosenquist R, Scollen S, Arenas Marquez J, Belien J, De Nicolo A, De Maria R, Torrents D, Tonon G. \"The 1+Million Genomes Minimal Dataset for Cancer\". Eng. In: Nat Genet. 56.5 (May. 2024), pp. 733-736.",
        doi: "10.1038/s41588-024-01721-x",
        pmid: "38702538"
      },
      {
        id: 17,
        citation: "Shah R, Loo CE, Hanna NM, Hughes S, Mafra A, Fink H, McFerran E, Garcia M, Acharya S, Langselius O, Frick C, Niyigaba J, Lasebikan N, Steinberg J, Sullivan R, Bray F, Ilbawi AM, Ginsburg O, Chiam K, Cylus J, Caruana M, David M, Hui H, Canfell K, Soerjomataram I. \"Global review of COVID-19 mitigation strategies and their impact on cancer service disruptions\". Eng. In: J Cancer Policy. 41 (Sep. 2024), p. 100486.",
        doi: "10.1016/j.jcpo.2024.100486",
        pmid: "38830535"
      },
      {
        id: 18,
        citation: "McFerran E, Donaldson S, Dolan O, Lawler M. \"Skin in the game: The cost consequences of skin cancer diagnosis, treatment and care in Northern Ireland\". Eng. In: J Cancer Policy. 39 (Mar. 2024), p. 100468.",
        doi: "10.1016/j.jcpo.2024.100468",
        pmid: "38311308"
      }
    ],
    2023: [
      {
        id: 1,
        citation: "O. Adair, E. McFerran, T. Owen, et al. \"A comparison of international modelling methods to evaluate health economics of colorectal cancer screening: a systematic review protocol\". Eng. In: Systematic reviews 12.1 (Jan. 2023), p. 14.",
        doi: "10.1186/s13643-023-02173-w",
        pmid: "36707908"
      },
      {
        id: 2,
        citation: "A. Aggarwal, A. Choudhury, N. Fearnhead, et al. \"The future of cancer care in the UK-time for a radical and sustainable National Cancer Plan\". Eng. In: The Lancet. Oncology 25.1 (Jan. 2024), pp. e6-e17.",
        doi: "10.1016/S1470-2045(23)00511-9",
        pmid: "37977167"
      },
      {
        id: 3,
        citation: "R. Amirkhah, K. Gilroy, S. B. Malla, et al. \"MmCMS: mouse models' consensus molecular subtypes of colorectal cancer\". Eng. In: British journal of cancer 128.7 (Mar. 2023), pp. 1333-1343.",
        doi: "10.1038/s41416-023-02157-6",
        pmid: "36717674"
      },
      {
        id: 4,
        citation: "M. Baumann, J. Celis, U. Ringborg, et al. \"Engaging European society at the forefront of cancer research and care: How discussions at the 5th Gago Conference on European Science policy led to the Heidelberg Manifesto\". Eng. In: Molecular oncology 17.6 (Jun. 2023), pp. 925-945.",
        doi: "10.1002/1878-0261.13423",
        pmid: "36938773"
      },
      {
        id: 5,
        citation: "I. Bondarenko, A. Agarwal, M. Van Hemelrijck, et al. \"Far-reaching impact of the Russian invasion of Ukraine on global cancer research\". Eng. In: European journal of cancer 183 (Apr. 2023), pp. 95-97.",
        doi: "10.1016/j.ejca.2023.01.020",
        pmid: "36812845"
      },
      {
        id: 6,
        citation: "R. Casolino, A. L. Johns, M. Courtot, et al. \"Accelerating cancer omics and precision oncology in health care and research: a Lancet Oncology Commission\". Eng. In: The Lancet. Oncology 24.2 (Feb. 2023), pp. 123-125.",
        doi: "10.1016/S1470-2045(23)00007-4",
        pmid: "36725142"
      },
      {
        id: 7,
        citation: "N. Couespel, E. Venegoni, and M. Lawler. \"The European Cancer Pulse: tracking inequalities in cancer control for citizen benefit\". Eng. In: The Lancet. Oncology 24.5 (May. 2023), pp. 441-442.",
        doi: "10.1016/S1470-2045(23)00140-7",
        pmid: "37142370"
      },
      {
        id: 8,
        citation: "K. B. Eckenrode, D. Righelli, M. Ramos, et al. \"Curated single cell multimodal landmark datasets for R/Bioconductor\". Eng. In: PLoS computational biology 19.8 (Aug. 2023), p. e1011324.",
        doi: "10.1371/journal.pcbi.1011324",
        pmid: "37624866"
      },
      {
        id: 9,
        citation: "D. J. Flanagan, R. Amirkhah, D. F. Vincent, et al. \"Author Correction: Epithelial TGFβ engages growth-factor signalling to circumvent apoptosis and drive intestinal tumourigenesis with aggressive features\". Eng. In: Nature communications 14.1 (Jan. 2023), p. 522.",
        doi: "10.1038/s41467-023-36266-w",
        pmid: "36720858"
      },
      {
        id: 10,
        citation: "G. J. Greene, C. S. Thomson, D. Donnelly, et al. \"Whole-population trends in pathology-confirmed cancer incidence in Northern Ireland, Scotland and Wales during the SARS-CoV-2 pandemic: A retrospective observational study\". Eng. In: Cancer epidemiology 84 (Jun. 2023), p. 102367.",
        doi: "10.1016/j.canep.2023.102367",
        pmid: "37119604"
      },
      {
        id: 11,
        citation: "J. Han, M. Rolles, F. Torabi, et al. \"The impact of the COVID-19 pandemic on community prescription of opioid and antineuropathic analgesics for cancer patients in Wales, UK\". Eng. In: Supportive care in cancer 31.9 (Aug. 2023), p. 531.",
        doi: "10.1007/s00520-023-07944-8",
        pmid: "37606853"
      },
      {
        id: 12,
        citation: "R. H. Henderson, D. French, E. Stewart, et al. \"Delivering the precision oncology paradigm: reduced R&D costs and greater return on investment through a companion diagnostic informed precision oncology medicines approach\". Eng. In: Journal of pharmaceutical policy and practice 16.1 (Jul. 2023), p. 84.",
        doi: "10.1186/s40545-023-00590-9",
        pmid: "37408046"
      },
      {
        id: 13,
        citation: "M. Lawler, G. Lewison, K. Oliver, et al. \"Gender inequity in cancer research leadership in Europe: Time to act\". Eng. In: European journal of cancer 194 (Nov. 2023), p. 113345.",
        doi: "10.1016/j.ejca.2023.113345",
        pmid: "37813780"
      },
      {
        id: 14,
        citation: "M. Lawler, R. Sullivan, G. K. Abou-Alfa, et al. \"Health diplomacy in action: The cancer legacy of the Good Friday Agreement\". Eng. In: Journal of cancer policy 38 (Dec. 2023), p. 100448.",
        doi: "10.1016/j.jcpo.2023.100448",
        pmid: "37839622"
      },
      {
        id: 15,
        citation: "M. P. Lythgoe, G. Lewison, A. Aggarwal, et al. \"The rise of immuno-oncology in China: a challenge to western dominance?\" Eng. In: The Lancet. Oncology 24.5 (May. 2023), pp. 439-441.",
        doi: "10.1016/S1470-2045(23)00026-8",
        pmid: "37142369"
      },
      {
        id: 16,
        citation: "E. McFerran, V. Cairnduff, R. Elder, et al. \"Cost consequences of unscheduled emergency admissions in cancer patients in the last year of life\". Eng. In: Supportive care in cancer 31.3 (Mar. 2023), p. 201.",
        doi: "10.1007/s00520-023-07633-6",
        pmid: "36869930"
      },
      {
        id: 17,
        citation: "S. O'Reilly, H. K. Carroll, D. Murray, et al. \"Impact of the COVID-19 pandemic on cancer care in Ireland - Perspectives from a COVID-19 and Cancer Working Group\". Eng. In: Journal of cancer policy 36 (Jun. 2023), p. 100414.",
        doi: "10.1016/j.jcpo.2023.100414",
        pmid: "36841473"
      },
      {
        id: 18,
        citation: "T. Sessler, G. P. Quinn, M. Wappett, et al. \"surviveR: a flexible shiny application for patient survival analysis\". Eng. In: Scientific reports 13.1 (Dec. 2023), p. 22093.",
        doi: "10.1038/s41598-023-48894-9",
        pmid: "38086891"
      },
      {
        id: 19,
        citation: "R. d. M. Simoes, R. Shirasaki, S. L. Downey-Kopyscinski, et al. \"Genome-scale functional genomics identify genes preferentially essential for multiple myeloma cells compared to other neoplasias\". Eng. In: Nature cancer 4.5 (May. 2023), pp. 754-773.",
        doi: "10.1038/s43018-023-00550-x",
        pmid: "37237081"
      },
      {
        id: 20,
        citation: "K. Taylor, J. Zou, M. Magalhaes, et al. \"Circulating tumour DNA kinetics in recurrent/metastatic head and neck squamous cell cancer patients\". Eng. In: European journal of cancer 188 (Jul. 2023), pp. 29-38.",
        doi: "10.1016/j.ejca.2023.04.014",
        pmid: "37182343"
      }
    ],
    2022: [
      {
        id: 1,
        citation: "A. Banerjee, C. Sudlow, and M. Lawler. \"Indirect effects of the pandemic: highlighting the need for data-driven policy and preparedness\". Eng. In: Journal of the Royal Society of Medicine 115.7 (Jul. 2022), pp. 249-251.",
        doi: "10.1177/01410768221095245",
        pmid: "35537476"
      },
      {
        id: 2,
        citation: "M. Begum, G. Lewison, X. Wang, et al. \"Global colorectal cancer research, 2007-2021: Outputs and funding\". Eng. In: International journal of cancer 152.3 (Feb. 2023), pp. 470-479.",
        doi: "10.1002/ijc.34279",
        pmid: "36082449"
      },
      {
        id: 3,
        citation: "G. Buyens, M. van Balken, K. Oliver, et al. \"Cancer literacy - Informing patients and implementing shared decision making\". Eng. In: Journal of cancer policy 35 (Dec. 2022), p. 100375.",
        doi: "10.1016/j.jcpo.2022.100375",
        pmid: "36462750"
      },
      {
        id: 4,
        citation: "S. M. Corry, A. M. McCorry, T. R. Lannagan, et al. \"Activation of innate-adaptive immune machinery by poly(I:C) exposes a therapeutic vulnerability to prevent relapse in stroma-rich colon cancer\". Eng. In: Gut 71.12 (Dec. 2022), pp. 2502-2517.",
        doi: "10.1136/gutjnl-2021-326183",
        pmid: "35477539"
      },
      {
        id: 5,
        citation: "S. Creedican, C. M. Robinson, K. Mnich, et al. \"Inhibition of IRE1α RNase activity sensitizes patient-derived acute myeloid leukaemia cells to proteasome inhibitors\". Eng. In: Journal of cellular and molecular medicine 26.16 (Aug. 2022), pp. 4629-4633.",
        doi: "10.1111/jcmm.17479",
        pmid: "35822520"
      },
      {
        id: 6,
        citation: "S. Elizabeth, K. Aidan, O. B. David, et al. \"Low CD49d expression in newly diagnosed chronic lymphocytic leukaemia may be associated with high-risk features and reduced treatment-free-intervals\". Eng. In: European journal of haematology 109.5 (Nov. 2022), pp. 441-446.",
        doi: "10.1111/ejh.13824",
        pmid: "35776688"
      },
      {
        id: 7,
        citation: "N. C. Fisher, R. M. Byrne, H. Leslie, et al. \"Biological Misinterpretation of Transcriptional Signatures in Tumor Samples Can Unknowingly Undermine Mechanistic Understanding and Faithful Alignment with Preclinical Data\". Eng. In: Clinical cancer research 28.18 (Sep. 2022), pp. 4056-4069.",
        doi: "10.1158/1078-0432.CCR-22-1102",
        pmid: "35792866"
      },
      {
        id: 8,
        citation: "D. J. Flanagan, R. Amirkhah, D. F. Vincent, et al. \"Epithelial TGFβ engages growth-factor signalling to circumvent apoptosis and drive intestinal tumourigenesis with aggressive features\". Eng. In: Nature communications 13.1 (Dec. 2022), p. 7551.",
        doi: "10.1038/s41467-022-35134-3",
        pmid: "36477656"
      },
      {
        id: 9,
        citation: "G. Greene, R. Griffiths, J. Han, et al. \"Impact of the SARS-CoV-2 pandemic on female breast, colorectal and non-small cell lung cancer incidence, stage and healthcare pathway to diagnosis during 2020 in Wales, UK, using a national cancer clinical record system\". Eng. In: British journal of cancer 127.3 (Aug. 2022), pp. 558-568.",
        doi: "10.1038/s41416-022-01830-6",
        pmid: "35501391"
      },
      {
        id: 10,
        citation: "R. H. Henderson, D. French, E. McFerran, et al. \"Spend less to achieve more: Economic analysis of intermittent versus continuous cetuximab in KRAS wild-type patients with metastatic colorectal cancer\". Eng. In: Journal of cancer policy 33 (Sep. 2022), p. 100342.",
        doi: "10.1016/j.jcpo.2022.100342",
        pmid: "35718327"
      },
      {
        id: 11,
        citation: "G. Lambe, S. Doran, R. Clifford, et al. \"Isolated CNS relapse of medullary aggressive high-grade B-cell lymphoma on 18F-FDG-PET/CT\". Eng. In: European journal of hybrid imaging 6.1 (May. 2022), p. 9.",
        doi: "10.1186/s41824-022-00130-9",
        pmid: "35501493"
      },
      {
        id: 12,
        citation: "M. Lawler and M. Crul. \"Data must underpin our response to the covid-19 pandemic's disastrous impact on cancer\". Eng. In: BMJ (Clinical research ed.) 376 (Feb. 2022), p. o282.",
        doi: "10.1136/bmj.o282",
        pmid: "35115384"
      },
      {
        id: 13,
        citation: "M. Lawler, L. Davies, S. Oberst, et al. \"European Groundshot-addressing Europe's cancer research challenges: a Lancet Oncology Commission\". Eng. In: The Lancet. Oncology 24.1 (Jan. 2023), pp. e11-e56.",
        doi: "10.1016/S1470-2045(22)00540-X",
        pmid: "36400101"
      },
      {
        id: 14,
        citation: "M. Lawler and F. Meunier. \"Don't make cancer survivors pay twice-the right for them to be \"forgotten\" should be law everywhere\". Eng. In: BMJ (Clinical research ed.) 378 (Sep. 2022), p. o2197.",
        doi: "10.1136/bmj.o2197",
        pmid: "36130783"
      },
      {
        id: 15,
        citation: "E. Nolte, M. Morris, S. Landon, et al. \"Exploring the link between cancer policies and cancer survival: a comparison of International Cancer Benchmarking Partnership countries\". Eng. In: The Lancet. Oncology 23.11 (Nov. 2022), pp. e502-e514.",
        doi: "10.1016/S1470-2045(22)00450-8",
        pmid: "36328024"
      },
      {
        id: 16,
        citation: "G. P. Quinn, T. Sessler, B. Ahmaderaghi, et al. \"classifieR a flexible interactive cloud-application for functional annotation of cancer transcriptomes\". Eng. In: BMC bioinformatics 23.1 (Mar. 2022), p. 114.",
        doi: "10.1186/s12859-022-04641-x",
        pmid: "35361119"
      },
      {
        id: 17,
        citation: "P. Robbe, K. E. Ridout, D. V. Vavoulis, et al. \"Whole-genome sequencing of chronic lymphocytic leukemia identifies subgroups with distinct biological and clinical features\". Eng. In: Nature genetics 54.11 (Nov. 2022), pp. 1675-1689.",
        doi: "10.1038/s41588-022-01211-y",
        pmid: "36333502"
      },
      {
        id: 18,
        citation: "R. Sullivan, G. Lewison, J. Torode, et al. \"Cancer research collaboration between the UK and the USA: reflections on the 2021 G20 Summit announcement\". Eng. In: The Lancet. Oncology 23.4 (Apr. 2022), pp. 460-462.",
        doi: "10.1016/S1470-2045(22)00079-1",
        pmid: "35358453"
      },
      {
        id: 19,
        citation: "H. Van Poppel, N. M. L. Battisti, M. Lawler, et al. \"European Cancer Organisation's Inequalities Network: Putting Cancer Inequalities on the European Policy Map\". Eng. In: JCO global oncology 8 (Oct. 2022), p. e2200233.",
        doi: "10.1200/GO.22.00233",
        pmid: "36252165"
      },
      {
        id: 20,
        citation: "Y. Wang, A. Buck, M. Grimaud, et al. \"Anti-CAIX BBζ CAR4/8 T cells exhibit superior efficacy in a ccRCC mouse model\". Eng. In: Molecular therapy oncolytics 24 (Mar. 2022), pp. 385-399.",
        doi: "10.1016/j.omto.2021.12.019",
        pmid: "35118195"
      }
    ]
  };

  export default PublicationsData